import React from 'react'
import usePopUp from './use-popup'

export default function WhenPopUpActive ({ children }) {
  const { active } = usePopUp()

  return active ? children : null
}
